module.exports = __webpack_public_path__ + "static/img/remote_study.d53dec04.jpg";